import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

export default function EditorialMarquee({
  items = ["MIKE MILLZZ", "GET-LOW", "SOUTHERN SMOKE", "OUT NOW"],
  speed = 45,
  outline = false,
  className = "",
}) {
  return (
    <div data-testid="editorial-marquee" className={`overflow-hidden border-y border-white/10 py-6 ${className}`}>
      <Marquee speed={speed} gradient={false}>
        {items.map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span
              className={`font-anton text-5xl uppercase md:text-7xl ${
                outline ? "text-outline" : "text-white"
              }`}
            >
              {item}
            </span>
            <Asterisk className="h-10 w-10 text-primary" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
